export default [
    { key: 'numberOfUserInteractionsLastDay', display: 'UIs last 24h' },
    { key: 'numberOfUserInteractions', display: 'UIs last week' },
    // { key: 'sysvolDeviation', display: 'Sysvol deviation' },
    { key: 'zonesNotRegulating', display: 'Zones w reg off' },
    { key: 'zonesNotRegulatingAudioSource', display: 'Zones source off' },
    { key: 'zonesWithMoodSustain', display: 'Zones w sustain' },
    { key: 'zonesMuted', display: 'Zones muted' },
    { key: 'averageVibe', display: 'Average vibe' },
]